import { render, staticRenderFns } from "./voucher.vue?vue&type=template&id=2e44e595&scoped=true&lang=html&"
import script from "./voucher.vue?vue&type=script&lang=js&"
export * from "./voucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e44e595",
  null
  
)

export default component.exports